function checkCheckbox() {
    const checkbox = document.getElementById('whitepaperCheck') as HTMLInputElement;
    if (checkbox) {
      checkbox.checked = true;
    }
}

export default checkCheckbox